module.exports = __webpack_public_path__ + "templates/cart-order.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-order.html
// module id = 37s3
// module chunks = 1